import React from 'react';
import logo from '../../assets/images/logo.svg';
import i18n from 'react-intl-universal';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';

const ErrorMessage = props => {
  const { classes, msg, withLogo } = props;

  return (
    <div>
      {withLogo ? (
        <img
          className={classes.logo}
          src={logo}
          alt={i18n.get('app.siteName')}
        />
      ) : null}

      <div className={classes.content}>
        <Typography
          variant="display2"
          gutterBottom
          className={classnames(classes.text, classes.megaText)}
        >
          {msg.heading}
        </Typography>
        <Typography variant="headline" gutterBottom className={classes.text}>
          {msg.remedy}
        </Typography>
        <Typography variant="title" gutterBottom className={classes.text}>
          {i18n.get('app.commons.errors.global.ifPersists')}
        </Typography>
        <Typography className={classes.errorReasonText}>
          {msg.reason}
        </Typography>
      </div>
    </div>
  );
};

export default withStyles(styles)(ErrorMessage);
